import * as React from "react";
const SvgFiRrAlarmExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-alarm-exclamation_svg__a)">
      <path
        fill="#062147"
        d="M13 2.046V1a1 1 0 1 0-2 0v1.046C5.401 2.553 1 7.272 1 13c0 2.738 1.006 5.246 2.667 7.173C2.821 20.622 2 21.49 2 23a1 1 0 1 0 2 0c0-1 .858-1.194 1.11-1.229q.106-.012.202-.044A10.95 10.95 0 0 0 11.999 24c2.513 0 4.835-.849 6.69-2.275q.09.03.188.044c.264.036 1.122.23 1.122 1.23a1 1 0 1 0 2 0c0-1.51-.821-2.378-1.667-2.827a10.95 10.95 0 0 0 2.667-7.173c0-5.728-4.401-10.447-10-10.954zM3 13c0-4.963 4.037-9 9-9s9 4.037 9 9-4.037 9-9 9-9-4.037-9-9m21-8.5a1 1 0 1 1-2 0c0-1.212-.977-2.5-2.785-2.5a1 1 0 1 1 0-2C21.899 0 24 1.977 24 4.5m-23 1a1 1 0 0 1-1-1C0 1.977 2.102 0 4.785 0a1 1 0 1 1 0 2C2.976 2 2 3.288 2 4.5a1 1 0 0 1-1 1M13 7v7a1 1 0 1 1-2 0V7a1 1 0 1 1 2 0m.5 11.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-alarm-exclamation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAlarmExclamation;
